import { render, staticRenderFns } from "./Printer.vue?vue&type=template&id=5138abb9"
import script from "./Printer.vue?vue&type=script&lang=ts"
export * from "./Printer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports